module.exports = __webpack_public_path__ + "media/categories/languages-3583d0ae.svg";